import note from '@/api/note'
import { mergeUserContext } from '@/store/helpers'

const NoteModel = {
  id: '',
  title: '',
  note: '',
  noteType: ''
}

// initial state
const state = {
  allNotes: [],
  viewNote: _.clone(NoteModel),
  personNotes: [],
  createNote: _.clone(NoteModel),
  editNote: _.clone(NoteModel)
}

// getters
const getters = {
  getAllNotes: state => state.allNotes,
  getViewNote: state => state.viewNote,
  getPersonNotes: state => state.personNotes,
  getCreateNote: state => state.createNote,
  getEditNote: state => state.editNote
}

// actions
const actions = {
  async getPersonNotes ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await note.getPersonNotes(payload)
    response.body.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt)
    })
    commit('setPersonNotes', response.body)
    return response.body
  },
  async createNote ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    delete payload.id

    var response = await note.createNote(payload)
    if (response.ok) {
      commit('addPersonNote', response.body)
      commit('resetCreateNote')
    }

    return response.body
  },
  async updateNote ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    var response = await note.updateNote(payload)

    if (response.ok) {
      commit('UPDATE_PERSON_NOTE', response.body)
      commit('SET_EDIT_NOTE', response.body)
    }

    return response.body
  }
}

// mutations
const mutations = {
  setPersonNotes (state, records) {
    state.personNotes = records
  },
  SET_VIEW_NOTE (state, record) {
    if (!record) {
      record = _.clone(NoteModel)
    }

    state.viewNote = record
  },
  SET_EDIT_NOTE (state, record) {
    if (!record) {
      record = _.clone(NoteModel)
    }

    state.editNote = record
  },
  RESET_VIEW_NOTE (state) {
    state.viewNote = _.clone(NoteModel)
    console.log('viewNote', state.viewNote)
  },
  addPersonNote (state, record) {
    state.personNotes.unshift(record)
  },
  UPDATE_PERSON_NOTE (state, record) {
    const noteIndex = _.findIndex(state.personNotes, (n) => n.id === record.id)
    state.personNotes.splice(noteIndex, 1)
    state.personNotes.splice(noteIndex, 0, record)
  },
  resetCreateNote (state) {
    state.createNote = _.clone(NoteModel)
  },
  UPDATE_TRANSFERRED_NOTE (state, record) {
    state.viewNote = record
    // TO DO - Update personNotes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/note.js